import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { ArrowLeft, Send, Loader2 } from 'lucide-react';
import SalePageNavbar from '../../components/SalePageNavbar';

const TestPaymentNotification: React.FC = () => {
  const navigate = useNavigate();
  const [salePageSlug, setSalePageSlug] = useState('');
  const [packageName, setPackageName] = useState('แพ็คเก็จทดสอบ');
  const [packagePrice, setPackagePrice] = useState('999');
  const [customerName, setCustomerName] = useState('ทดสอบ ระบบ');
  const [customerPhone, setCustomerPhone] = useState('081-234-5678');
  const [customerEmail, setCustomerEmail] = useState('test@example.com');
  const [customerAddress, setCustomerAddress] = useState('123 ถนนทดสอบ');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!salePageSlug) {
      alert('กรุณากรอก Sale Page Slug');
      return;
    }

    try {
      setIsSubmitting(true);
      
      await addDoc(collection(db, 'paymentNotifications'), {
        salePageSlug,
        packageId: 'test-' + Date.now(),
        packageName,
        packagePrice,
        slipUrl: 'https://via.placeholder.com/400x600/FF6B35/FFFFFF?text=Test+Slip',
        customerName,
        customerAddress,
        customerPhone,
        customerEmail,
        status: 'pending',
        createdAt: serverTimestamp()
      });

      alert('✅ สร้างข้อมูลทดสอบสำเร็จ!\n\nกลับไปที่ Dashboard เพื่อดูการแจ้งเตือน');
      navigate('/salepage/dashboard');
    } catch (error) {
      console.error('Error creating test notification:', error);
      alert('เกิดข้อผิดพลาด: ' + (error as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <SalePageNavbar />
      <div className="min-h-screen bg-[#F3F8F8] pt-20 py-8">
        <div className="container mx-auto px-4 max-w-2xl">
          <button
            onClick={() => navigate('/salepage/dashboard')}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="font-medium">กลับ Dashboard</span>
          </button>

          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold text-gray-900 mb-2">สร้างข้อมูลทดสอบ</h1>
              <p className="text-gray-600">สำหรับทดสอบระบบแจ้งเตือนการชำระเงิน</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">
                  Sale Page Slug *
                </label>
                <input
                  type="text"
                  value={salePageSlug}
                  onChange={(e) => setSalePageSlug(e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition-all"
                  placeholder="กรอก slug ของ Sale Page ที่คุณสร้าง"
                  required
                />
                <p className="text-xs text-gray-500 mt-1">
                  ตัวอย่าง: ถ้า URL คือ saledi.web.app/s/abc123 ให้กรอก "abc123"
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    ชื่อแพ็คเก็จ
                  </label>
                  <input
                    type="text"
                    value={packageName}
                    onChange={(e) => setPackageName(e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition-all"
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    ราคา (฿)
                  </label>
                  <input
                    type="text"
                    value={packagePrice}
                    onChange={(e) => setPackagePrice(e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition-all"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">
                  ชื่อลูกค้า
                </label>
                <input
                  type="text"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition-all"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    เบอร์โทร
                  </label>
                  <input
                    type="text"
                    value={customerPhone}
                    onChange={(e) => setCustomerPhone(e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition-all"
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    value={customerEmail}
                    onChange={(e) => setCustomerEmail(e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition-all"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">
                  ที่อยู่
                </label>
                <textarea
                  value={customerAddress}
                  onChange={(e) => setCustomerAddress(e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-400 focus:border-orange-400 transition-all"
                  rows={3}
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-4 bg-gradient-to-r from-orange-500 to-amber-500 text-white rounded-lg font-bold text-lg hover:shadow-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {isSubmitting ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    กำลังสร้างข้อมูล...
                  </>
                ) : (
                  <>
                    <Send className="w-5 h-5" />
                    สร้างข้อมูลทดสอบ
                  </>
                )}
              </button>
            </form>

            <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-sm text-blue-800">
                <strong>หมายเหตุ:</strong> หน้านี้ใช้สำหรับทดสอบระบบเท่านั้น 
                ข้อมูลที่สร้างจะแสดงในหน้า Dashboard พร้อมการแจ้งเตือน
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestPaymentNotification;
